module.exports = __webpack_public_path__ + "static/media/bg-image.ccf23ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-image.png
// module id = 1257
// module chunks = 1